import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { NewRobotIdE, useConnectedRafts } from "../../../../store/SelectedRaftContext";
import Logger from "../../../../services/logger/Logger";

const SHOW_LOGS = true;
const TAG = "Diagnostics";

const Diagnostics = () => {
  const { connectedRafts } = useConnectedRafts();
  const selectedRaft = connectedRafts.find(connectedRaft => connectedRaft.isSelected && connectedRaft.id !== NewRobotIdE.NEW);

  const [rxRate, setRxRate] = useState("");
  const [worstMs, setWorstMs] = useState(0);
  const [lastMs, setLastMs] = useState(0);
  const [bestMs, setBestMs] = useState(0);
  const [retries, setRetries] = useState(0);

  const updateDebugInfo = async () => {
    if (!selectedRaft) {
      Logger.error(SHOW_LOGS, TAG, "No selected raft found");
      return;
    }
    const fetchedStats = await window.applicationManager.getCommsStatsMarty(selectedRaft.id);
    if (!fetchedStats) {
      Logger.error(SHOW_LOGS, TAG, "No stats found");
      return;
    }
    const fetchedRxRate = (
      Math.round(fetchedStats.msgRxRate * 100) / 100
    ).toFixed(2);
    const fetchedWorstMs = fetchedStats.msgRoundtripWorstMs;
    const fetchedLastMs = fetchedStats.msgRoundtripLastMs;
    const fetchedBestMs = fetchedStats.msgRoundtripBestMs;
    const fetchedRetries = fetchedStats.msgRetries;
    setRxRate(fetchedRxRate);
    setWorstMs(fetchedWorstMs);
    setLastMs(fetchedLastMs);
    setBestMs(fetchedBestMs);
    setRetries(fetchedRetries);
  };

  useEffect(() => {
    const updateInterval = setInterval(() => {
      updateDebugInfo();
    }, 300);

    return () => clearInterval(updateInterval);
  }, []);

  return (
    <div className={styles["diagnostics-screen-container"]}>
      <ul className={styles["diagnostics-screen-list-container"]}>
        <li>rxRate: {rxRate}</li>
        <li>Worst ms: {worstMs}</li>
        <li>Last ms: {lastMs}</li>
        <li>Best ms: {bestMs}</li>
        <li>Retries: {retries}</li>
      </ul>
    </div>
  );
};

export default Diagnostics;
